// extracted by mini-css-extract-plugin
export default {"page-primary-color":"#000000","pagePrimaryColor":"#000000","badge":"sv0UV undefined"};